import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { getCheckoutUrl } from '../utils/getCheckoutUrl';
import { trackAddToCart } from '../utils/metaPixel';
interface ClosingSectionProps {
  addedBumps: Record<string, boolean>;
}
export function ClosingSection({
  addedBumps
}: ClosingSectionProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-28 px-6 bg-dark-tertiary relative overflow-hidden" data-id="element-41">
      <div className="max-w-4xl mx-auto text-center relative" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-43">
          <p className="text-xl md:text-2xl text-text-secondary leading-relaxed mb-2" data-id="element-44">
            Puedes seguir viendo contenido…
          </p>
          <p className="text-2xl md:text-3xl font-serif font-bold text-text-primary mt-6" data-id="element-45">
            o empezar a crearlo.
          </p>
        </motion.div>

        <motion.a href={getCheckoutUrl(addedBumps)} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.3
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="inline-block px-12 py-6 bg-accent text-dark-bg font-bold text-xl rounded-lg hover:bg-accent/90 transition-all shadow-2xl shadow-accent/30" data-id="element-46">
          Sí, quiero empezar ahora
        </motion.a>
      </div>
    </section>;
}